import { render, staticRenderFns } from "./BreakoutGroup.vue?vue&type=template&id=ca1b37cc&scoped=true&lang=pug"
import script from "./BreakoutGroup.vue?vue&type=script&lang=ts"
export * from "./BreakoutGroup.vue?vue&type=script&lang=ts"
import style0 from "./BreakoutGroup.vue?vue&type=style&index=0&id=ca1b37cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1b37cc",
  null
  
)

export default component.exports